import { unavailableOnWeb } from './unavailableOnWeb.web';
const isAvailable = async () => false;
const InAppBrowser = {
    isAvailable,
    open: unavailableOnWeb('InAppBrowser.open'),
    openAuth: unavailableOnWeb('InAppBrowser.openAuth'),
    close: () => { },
};
export { isAvailable };
export default InAppBrowser;
